import { useEffect, useRef } from "react"
import Mark from "mark.js"
import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { cn } from "@/lib/utils"

interface HighlightedTextProps extends React.ComponentPropsWithoutRef<"span"> {
  text: string
  searchValue: string
  extendedMarkClasses?: string
  ignoredDiacritics?: boolean
}

const HighlightedText = ({
  text,
  searchValue,
  extendedMarkClasses = "font-medium",
  ignoredDiacritics,
  className,
  ...props
}: HighlightedTextProps) => {
  const textRef = useRef(null)
  const markInstanceRef = useRef<Mark | null>(null)

  useEffect(() => {
    if (textRef.current) {
      if (!markInstanceRef.current) {
        markInstanceRef.current = new Mark(textRef.current)
      }

      markInstanceRef.current.unmark({
        done: () => {
          if (searchValue) {
            markInstanceRef.current?.mark(searchValue, {
              diacritics: ignoredDiacritics,
              className: cn("bg-success-surface-subdued text-on-success-surface", extendedMarkClasses),
            })
          }
        },
      })
    }
  }, [searchValue, text, extendedMarkClasses, ignoredDiacritics])

  return <PotentiallyUnsafeInnerHtml ref={textRef} className={cn("inline", className)} value={text} {...props} />
}

export { HighlightedText }
